function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PagingTable from '../common/pagingTable/pagingTable';
import cabinetActionCreators from '../../actions/cabinetActionCreators';
const cabinetPagingTable = () => {
  /**
   *  Map the subcabinet (state.cabinet[currentCabinet]) properties for paging
   */
  const mapStateToProps = state => {
    if (state.cabinet && state.cabinet.currentCabinet && state.cabinet[state.cabinet.currentCabinet]) {
      const cab = state.cabinet[state.cabinet.currentCabinet];
      const {
        hasNext = false,
        hasPrevious = false,
        indexQuery = {
          paging: {
            current: 0
          }
        }
      } = cab;
      return {
        hasNext,
        hasPrevious,
        indexQuery
      };
    }
    return {
      hasNext: false,
      hasPrevious: false,
      indexQuery: {
        paging: {
          current: 0
        }
      }
    };
  };
  const mapDispatchToProps = dispatch => {
    const actions = bindActionCreators(cabinetActionCreators, dispatch);
    return {
      handlePreviousPage: actions.pagePrevious,
      handleNextPage: actions.pageNext,
      sortBy: actions.sortBy
    };
  };
  const mergeProps = (stateProps, dispatchProps, ownProps) => _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, ownProps), stateProps), dispatchProps), {}, {
    sortBy: ownProps.sortBy || dispatchProps.sortBy
  });
  return connect(mapStateToProps, mapDispatchToProps, mergeProps)(PagingTable);
};
export default cabinetPagingTable();